<script setup lang="ts">
withDefaults(
  defineProps<{
    ariaLabel?: string
  }>(),
  {
    ariaLabel: 'Chargement du formulaire',
  },
)
</script>

<template>
  <div class="form-overlay-skeleton" aria-busy="true" :aria-label="ariaLabel">
    <div class="form-overlay-skeleton__title" />
    <div class="form-overlay-skeleton__fields">
      <div class="form-overlay-skeleton__line form-overlay-skeleton__line--input" />
      <div class="form-overlay-skeleton__line form-overlay-skeleton__line--input" />
      <div class="form-overlay-skeleton__line form-overlay-skeleton__line--input" />
      <div class="form-overlay-skeleton__line form-overlay-skeleton__line--textarea" />
    </div>
    <div class="form-overlay-skeleton__footer">
      <div class="form-overlay-skeleton__line form-overlay-skeleton__line--btn" />
      <div class="form-overlay-skeleton__line form-overlay-skeleton__line--btn" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "~/assets/scss/partials/elpdl/colors" as c;
@use "~/assets/scss/partials/elpdl/spacing" as *;

.form-overlay-skeleton {
  display: flex;
  flex-direction: column;
  gap: $spacing-m;
  width: 100%;
  min-width: 300px;
  min-height: 380px;
}

.form-overlay-skeleton__fields {
  display: flex;
  flex-direction: column;
  gap: $spacing-m;
}

.form-overlay-skeleton__footer {
  display: flex;
  justify-content: flex-end;
  gap: $spacing-m;
  margin-top: $spacing-2xs;
}

.form-overlay-skeleton__line,
.form-overlay-skeleton__title {
  border-radius: 6px;
  overflow: hidden;
  background: c.$enedis-neutral-40;
  position: relative;
}

.form-overlay-skeleton__line::after,
.form-overlay-skeleton__title::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    rgba(c.$enedis-neutral-40, 0) 0%,
    rgba(255, 255, 255, 0.7) 50%,
    rgba(c.$enedis-neutral-40, 0) 100%
  );
  animation: form-overlay-skeleton-shimmer 1.2s infinite;
}

.form-overlay-skeleton__title {
  height: 1.5rem;
  max-width: 70%;
}

.form-overlay-skeleton__line--input {
  height: 48px;
}

.form-overlay-skeleton__line--textarea {
  height: 80px;
}

.form-overlay-skeleton__line--btn {
  height: 40px;
  width: 100px;
}

@keyframes form-overlay-skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
